import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { FullTeamAssessmentService } from '../../../../shared/services/fullTeamAssessment.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { IFullTeamAssessment } from '../../../../shared/models/fullTeamAssessment';
import { DateUtils } from '../../../../shared/helpers/dateUtils';

@Component({
  selector: 'review-full-team-assessment',
  standalone: true,
  imports: [
    CommonModule, 
    SpinnerComponent
  ],
  templateUrl: './review-full-team-assessment.component.html',
  styleUrl: './review-full-team-assessment.component.css'
})
export class ReviewFullTeamAssessmentComponent implements OnInit {

  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  fullTeamThreatAssessment: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Assessment Information",
      children: [
        {
          type: 'date',
          questionText: "Form date started:",
          answer: "date_started"
        },
        {
          type: 'string',
          questionText: "Form time started:",
          answer: "time_started"
        },
        {
          type: 'string',
          questionText: "Sources of information used in this threat assessment:",
          answer: "source_of_information"
        }
      ]
    },
    {
      sectionName: "Threat Background and Motivation",
      children: [
        {
          type: 'date',
          questionText: "Date of incident:",
          answer: "date_of_incident"
        },
        {
          type: 'string',
          questionText: "Time of accident:",
          answer: "time_of_incident"
        },
        {
          type: 'string',
          questionText: "Describe in detail the situation that prompted this Behavioral Threat Assessment:",
          answer: "detail_of_situation"
        },
        {
          type: 'string',
          questionText: "Who was present during the situation? Please record full name(s) and contact information.",
          answer: "situation_presence"
        },
        {
          type: 'number',
          questionText: "Was there/were there specific target(s) identified? *",
          answer: "specific_target_identified"
        },
        {
          type: 'string',
          questionText: "Please identify the target(s):",
          answer: "specific_target_identified_information"
        }
      ]
    },
    {
      sectionName: "A. What are the student's motives and goals?",
      children: [
        {
          type: 'string',
          questionText: "What motivated the student to communicate the threat or take the concerning actions resulting in the assessment?",
          answer: "student_motivation"
        },
        {
          type: 'number',
          questionText: "Is the threat ongoing?",
          answer: "ongoing_threat"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "ongoing_threat_explanation"
        },
        {
          type: 'number',
          questionText: "Has any part of the threat been resolved?",
          answer: "threat_resolution"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "threat_resolution_explanation"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "a_additional_info"
        }
      ]
    },
    {
      sectionName: "B. Have there been any communications suggesting ideas or intent to attack?",
      children: [
        {
          type: 'string',
          questionText: "What, if anything, did the student communicate to others and when?",
          answer: "student_communication_others"
        },
        {
          type: 'string',
          questionText: "What was the context or physical location of this communication?",
          answer: "communication_context"
        },
        {
          type: 'string',
          questionText: "To whom and how did the student communicate his/her intentions?",
          answer: "communication_intentions"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "b_additional_info"
        }
      ]
    },
    {
      sectionName: "C. Has the student shown inappropriate/concerning interest in any of the following?",
      children: [
        {
          type: 'number',
          questionText: "School attacks or attackers?",
          answer: "school_attacks"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "school_attacks_explanation"
        },
        {
          type: 'number',
          questionText: "Weapons or dangerous materials?",
          answer: "weapons"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "weapons_explanation"
        },
        {
          type: 'number',
          questionText: "Incidents of mass violence (terrorism, workplace violence, mass murderers)?",
          answer: "mass_violence"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "mass_violence_explanation"
        },
        {
          type: 'number',
          questionText: "Preoccupation with death, violent themes or school attacks?",
          answer: "death_preoccupation"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "death_preoccupation_explanation"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "c_additional_info"
        }
      ]
    },
    {
      sectionName: "D. Does the student have the capacity (resources or ability) to carry out an act of targeted violence?",
      children: [
        {
          type: 'string',
          questionText: "How organized is the student's thinking and behavior in general? Please explain:",
          answer: "general_behavior_organization"
        },
        {
          type: 'string',
          questionText: "How organized is the student's thinking and behavior as it relates to this specific situation? Please explain:",
          answer: "specific_behavior_organization"
        },
        {
          type: 'number',
          questionText: "Does the student have the means (access to weapons or dangerous materials) to carry out an attack?",
          answer: "means_for_attack"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "means_for_attack_explanation"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "b_additional_info"
        }
      ]
    },
    {
      sectionName: "E. Is the student experiencing emotional or mental health concerns?",
      children: [
        {
          type: 'number',
          questionText: "Which, if any, of the following applies to the student? \n Is there information to suggest that the student is experiencing hopelessness, desperation or despair?",
          answer: "hopelessness_desperation"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "hopelessness_desperation_information"
        },
        {
          type: 'number',
          questionText: "Substance abuse?",
          answer: "substance_abuse"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "substance_abuse_information"
        },
        {
          type: 'number',
          questionText: "A known mental health diagnosis?",
          answer: "mental_health_diagnosis"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "mental_health_diagnosis_information"
        },
        {
          type: 'number',
          questionText: "Recent failure, loss, and/or loss of status?",
          answer: "recent_failure"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "recent_failure_information"
        },
        {
          type: 'number',
          questionText: "Othere emotional trauma?",
          answer: "emotional_trauma"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "emotional_trauma_information"
        },
        {
          type: 'number',
          questionText: "Difficulty coping with stressful events?",
          answer: "stressful_events"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "stressful_events_information"
        },
        {
          type: 'number',
          questionText: "Suicidal tendencies/ideation?",
          answer: "suicidal_tendencies"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "suicidal_tendencies_information"
        },
        {
          type: 'number',
          questionText: "Hospitalized for mental health reasons?",
          answer: "mental_health_hospitalization"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "mental_health_hospitalization_information"
        },
        {
          type: 'number',
          questionText: "Paranoid thinking?",
          answer: "paranoid_thinking"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "paranoid_thinking_information"
        },
        {
          type: 'number',
          questionText: "Obsessive thoughts?",
          answer: "obsessive_thoughts"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "obsessive_thoughts_information"
        },
        {
          type: 'number',
          questionText: "Homicidal ideation?",
          answer: "homicidal_ideation"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "homicidal_ideation_information"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "e_additional_info"
        }
      ]
    },
    {
      sectionName: "F. Does the student see violence as an acceptable, desirable, or the only way to solve problems?",
      children: [
        {
          type: 'number',
          questionText: "Has the student experienced any of the following? Victim of violent behavior? ",
          answer: "violent_behavior_victim"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "violent_behavior_victim_information"
        },
        {
          type: 'number',
          questionText: "Perpetrator of violent behavior?",
          answer: "violent_behavior_perpetrator"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "violent_behavior_perpetrator_information"
        },
        {
          type: 'number',
          questionText: "Witness of violent behavior?",
          answer: "violent_behavior_witness"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "violent_behavior_witness_information"
        },
        {
          type: 'number',
          questionText: "Criminal history of violent behavior?",
          answer: "violent_behavior_criminal"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "violent_behavior_criminal_information"
        },
        {
          type: 'number',
          questionText: "Exposed to violence? ",
          answer: "violence_exposure"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "violence_exposure_information"
        },
        {
          type: 'number',
          questionText: "Family history of violence?",
          answer: "family_violence"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "family_violence_information"
        },
        {
          type: 'number',
          questionText: "Does the student have a history of using violence as an acceptable or desirable way to solve problems?",
          answer: "acceptable_violence"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "acceptable_violence_information"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "f_additional_info"
        }
      ]
    },
    {
      sectionName: "G. Are other people concerned about the student's potential for violence?",
      children: [
        {
          type: 'number',
          questionText: "Are those who know the student concerned the he/she may take action on violent ideas/plans?",
          answer: "student_concern"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "student_concern_information"
        },
        {
          type: 'number',
          questionText: "Are those who know the student concerned about a specific target?",
          answer: "specific_target_concern"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "specific_target_concern_information"
        },
        {
          type: 'number',
          questionText: "Have those who know the student witnessed recent changes or escalations in mood and behavior?",
          answer: "recent_changes_behavior"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "recent_changes_behavior_information"
        },
        {
          type: 'number',
          questionText: "Does the student use terms to depersonalize or marginalize others? (Examples may include referring to others as 'it' or 'they', using derogatory statements or terms when referencing others.)",
          answer: "marginalize_others"
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "marginalize_others_information"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "g_additional_info"
        }
      ]
    },
    {
      sectionName: "H. Has the student engaged in attack related behaviors?",
      children: [
        {
          type: 'number',
          questionText: 'Does the student own or have access to weapons?',
          answer: 'weapons_access'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'weapons_access_information',
        },
        {
          type: 'number',
          questionText: 'Has the student used or practiced with weapons?',
          answer: 'weapons_practice'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'weapons_practice_information',
        },
        {
          type: 'number',
          questionText: 'Has the student attempted to acquire a weapon?',
          answer: 'acquire_weapon'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'acquire_weapon_information',
        },
        {
          type: 'number',
          questionText: 'Does the student have an attack plan?',
          answer: 'attack_plan'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'attack_plan_information',
        },
        {
          type: 'number',
          questionText: 'Has the student exhibited stalking behavior?',
          answer: 'stalking_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'stalking_behavior_information',
        },
        {
          type: 'number',
          questionText: 'Has the student exhibited boundary probing behavior (i.e., testing limits, seeing what he/she can get away with, escalating misbehavior)?',
          answer: 'boundary_probing'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'boundary_probing_information',
        },
        {
          type: 'number',
          questionText: 'Has the student engaged in desensitizing behavior in the real world or in the virtual world (i.e., practicing target shooting to get used to the feel of firing weapons, playing violent video games, practicing hurting animals)?',
          answer: 'desensitizing_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'desensitizing_behavior_information',
        },
        {
          type: 'number',
          questionText: "Has the student engaged in dehumanizing behavior in the real world or in the virtual world (i.e., referring to peers or siblings as 'it' or using a non-human classification)?* ",
          answer: 'dehumanizing_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'dehumanizing_behavior_information',
        },
        {
          type: 'number',
          questionText: 'Has the student exhibited casing behavior (i.e., taking photos of the school, acquiring maps or aerials)?',
          answer: 'casing_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'casing_behavior_information',
        },
        {
          type: 'number',
          questionText: 'Has the student exhibited any other suspicious behavior?',
          answer: 'suspicious_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'suspicious_behavior_information',
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "h_additional_info"
        }
      ]
    },
    {
      sectionName: "I. Corroborate the student's statement. Is the student's conversation and 'story' consistent with his/her actions?",
      children: [
        {
          type: 'number',
          questionText: "Are the student's statements consistent with his/her actions?",
          answer: 'student_statement'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'student_statement_information'
        },
        {
          type: 'number',
          questionText: "Are the student's statements or explanations consistent with what others know about the situation?",
          answer: 'student_other_knowledge'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'student_other_knowledge_information'
        },
        {
          type: 'number',
          questionText: "Are the student's actions consistent across other areas of their lives?",
          answer: 'student_actions_consistent'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'student_actions_consistent_information'
        },
        {
          type: 'number',
          questionText: "Are the student's current behaviors consistent with their past behaviors?",
          answer: 'student_current_behavior'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'student_current_behavior_information'
        },
        {
          type: 'number',
          questionText: "Is there a reason to believe that the student is manipulating others in this situation?",
          answer: 'student_manipulation'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'student_manipulation_information'
        },
        {
          type: 'number',
          questionText: "Is there evidence that the student has a history of fabricating stories?",
          answer: 'story_fabrication'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'story_fabrication_information'
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "i_additional_info"
        }
      ]
    },
    {
      sectionName: "J. Does the student have a positive, trusting relationship with an adult at school?",
      children: [
        {
          type: 'number',
          questionText: "Does the student have at least one healthy relationship with an adult in school with whom he/she can confide in and trust?",
          answer: 'positive_relationship_adult'
        },
        {
          type: 'string',
          questionText: 'With whom:',
          answer: 'positive_relationship_adult_contact'
        },
        {
          type: 'number',
          questionText: "Does the student have at least one healthy relationship with an adult outside of school with whom he/she can confide in and trust?",
          answer: 'positive_relationship_outside'
        },
        {
          type: 'string',
          questionText: 'With whom:',
          answer: 'positive_relationship_outside_contact'
        },
        {
          type: 'number',
          questionText: "Does the student have positive peer relationships?",
          answer: 'positive_peer_relationship'
        },
        {
          type: 'string',
          questionText: 'With whom:',
          answer: 'positive_peer_relationship_contact'
        },
        {
          type: 'number',
          questionText: "Has the student previously come to someone's attention or raised concern in a way that suggested he/she needed intervention or supportive services:",
          answer: 'student_raise_concern'
        },
        {
          type: 'string',
          questionText: "Please explain:",
          answer: "student_raise_concern_information"
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "j_additional_info"
        }
      ] 
    },
    {
      sectionName: "K. What additional circumstances might affect the likelihood of an attack?",
      children: [
        {
          type: 'number',
          questionText: 'Family history of mental illness?',
          answer: 'family_mental'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'family_mental_information',
        },
        {
          type: 'number',
          questionText: 'Current events that might trigger a violent reaction (anniversary of an event, recent school shooting)?',
          answer: 'current_events'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'current_events_information',
        },
        {
          type: 'number',
          questionText: 'Family substance abuse?',
          answer: 'family_substance_abuse'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'family_substance_abuse_information',
        },
        {
          type: 'number',
          questionText: 'Frequent mobility?',
          answer: 'frequency_mobility'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'frequency_mobility_information',
        },
        {
          type: 'number',
          questionText: 'Family instability?',
          answer: 'family_instability'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'family_instability_information',
        },
        {
          type: 'number',
          questionText: 'Lack of supervision?',
          answer: 'lack_supervision'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'lack_supervision_information',
        },
        {
          type: 'number',
          questionText: 'Victim of bullying?',
          answer: 'bully_victim'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'bully_victim_information',
        },
        {
          type: 'number',
          questionText: "Perpetrator of bullying?",
          answer: 'bully_perpetrator'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'bully_perpetrator_information',
        },
        {
          type: 'number',
          questionText: 'Victim of abuse and/or trauma?',
          answer: 'abuse_victim'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'abuse_victim_information',
        },
        {
          type: 'number',
          questionText: 'Negative peer group influence?',
          answer: 'negative_peer'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'negative_peer_information',
        },
        {
          type: 'number',
          questionText: "Antisocial attitude?",
          answer: 'antisocial_attitude'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'antisocial_attitude_information',
        },
        {
          type: 'number',
          questionText: "Encouragement from others to carry out a plan or attack?",
          answer: 'attack_encouragement'
        },
        {
          type: 'string',
          questionText: 'Please explain:',
          answer: 'attack_encouragement_information',
        },
        {
          type: 'number',
          questionText: "Is further investigation or additional information needed to complete this section?",
          answer: "k_additional_info"
        }
      ]
    },
    {
      sectionName: "L. Is Further Investigation Needed To Make A Determination?",
      children: [
        {
          type: 'number',
          questionText: 'Motives and Goals:',
          answer: 'a_additional_info'
        },
        {
          type: 'number',
          questionText: 'Communications Suggesting Intent:',
          answer: 'b_additional_info'
        },
        {
          type: 'number',
          questionText: 'Inappropriate or Concerning Interests:',
          answer: 'c_additional_info'
        },
        {
          type: 'number',
          questionText: ' Attack Related Behaviors:',
          answer: 'd_additional_info'
        },
        {
          type: 'number',
          questionText: 'Capacity to Carry Out Violence:',
          answer: 'e_additional_info'
        },
        {
          type: 'number',
          questionText: 'Behavioral or Mental Health Concerns:',
          answer: 'f_additional_info'
        },
        {
          type: 'number',
          questionText: 'Trusting Relationships:',
          answer: 'g_additional_info'
        },
        {
          type: 'number',
          questionText: 'Violence as a Problem-Solving Method:',
          answer: 'h_additional_info'
        },
        {
          type: 'number',
          questionText: 'Consistency between Story and Actions:',
          answer: 'i_additional_info'
        },
        {
          type: 'number',
          questionText: 'Concerns about Potential for Violence:',
          answer: 'j_additional_info'
        },
        {
          type: 'number',
          questionText: 'Additional Circumstances:',
          answer: 'k_additional_info'
        }
      ]
    },
    {
      sectionName: "M. Team Determination",
      children: [
        {
          type: 'number',
          questionText: 'Select one of the two following statements:',
          answer: 'team_determination'
        },
        {
          type: 'number',
          questionText: "Select the statement that best reflects the team's determination:",
          answer: 'team_determination_selection'
        },
        {
          type: 'date',
          questionText: 'Date to reconvene as a team to complete the team determination.',
          answer: 'team_determination_plan_date'
        }
      ]
    },
    {
      sectionName: "N. Suicide Assessment",
      children: [
        {
          type: 'number',
          questionText: 'In some situations, a Suicide Risk Assessment may be warranted in addition to the Behavioral Threat Assessment. Does this situation warrant the completion of a Suicide Risk Assessment in addition to a Threat Assessment?',
          answer: 'suicide_risk_assessment'
        },
        {
          type: 'string',
          questionText: "Identify who, on this team, is responsible for ensuring that a Suicide Risk Assessment occurs. Name of person completing the suicide assessment:",
          answer: 'suicide_risk_assessment_person'
        },
        {
          type: 'date',
          questionText: 'When:',
          answer: 'suicide_risk_assessment_date'
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "user_signature_date_time"
        }
      ]
    }
  ];

  constructor(
    private fullTeamAssessmentService: FullTeamAssessmentService
  ) { }

  ngOnInit(): void {
    this.loadFullTeamThreatAssessment();
  }

  loadFullTeamThreatAssessment(): void {
    if (this.caseId) {
      this.loading = true;      
      this.fullTeamAssessmentService.getFullTeamAssessmentByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.fullTeamThreatAssessment = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching full team threat assessment:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }
}
